import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getJobDetails } from "../../slice/workerJobSlice";
import { useParams } from 'react-router-dom';
import { toast } from "react-toastify";
import { getResumeList, addJobApplication } from "../../slice/workerResumeSlice";
import { getInfo } from "../../slice/workerInfoSlice";
import WorkerHeader from "../../../worker-header/components/index";
import WorkerFooter from "../../../worker-footer/components/index";
import { useNavigate } from "react-router-dom";

const WorkerJobDetails = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const { jobDetails, loading, error } = useSelector((state) => state.workerJob);
  const isVerified = useSelector(
    (state) => state.workerInfo.userData?.is_verify === 1
  );
  const isCompliance = useSelector(
    (state) => state.workerInfo.userData?.is_compliance === 1
  );
  const { resumeData } = useSelector((state) => state.workerResume);
  const { userData } = useSelector(
    (state) => state.workerInfo
  );
  const search = "";
  const [showModal, setShowModal] = useState(false);
  const [selectedResume, setSelectedResume] = useState("");
  const [coverLetter, setCoverLetter] = useState("");

  const handleApply = () => {
    if (!selectedResume) {
      toast.error("Please select resume");
      return;
    }

    if (!coverLetter) {
      toast.error("Please write cover letter");
      return;
    }

    const formData = {
      job_id: Number(job.id),
      resume_id: Number(selectedResume),
      cover_letter: coverLetter,
    };

    dispatch(addJobApplication({ token, formData }))
      .unwrap()
      .then(() => {
        toast.success("Applied successfully");
        setShowModal(false);
        dispatch(getJobDetails({ id, token }));
      })
      .catch((err) => {
        console.error(err);
        toast.error(err?.message || "Failed to apply");
      });
  };

  useEffect(() => {
    dispatch(getJobDetails({ id }));
    dispatch(getInfo(token));
    dispatch(getResumeList({ search, token }));
  }, [id, token, dispatch]);

  const getStatusClass = (status) => {
    switch (status?.toLowerCase()) {
      case "published":
        return "bg-success";
      case "draft":
        return "bg-warning text-dark";
      case "expired":
        return "bg-danger";
      default:
        return "bg-secondary";
    }
  };

  // if (loading) {
  //   return <p>Loading job details...</p>;
  // }

  // if (error) {
  //   return <p className="text-danger">{error}</p>;
  // }

  if (!jobDetails) {
    return null;
  }

  const job = jobDetails;
  const isApplied = job.is_applied === 1;

  const { role_id } = userData;

  return (
    <>
      <WorkerHeader />
      <main className="overflow-hidden">
        <section className="homepad" style={{ minHeight: "60vh" }}>
          <div className="container">
            <div className="row d-flex align-items-stretch">
              <div className="col-lg-8 services-listpage">
                <div className="form-section rounded p-3 p-sm-4">
                  <h4 className="font-weight-bold text-primary font-size-40 mb-4 pb-1 line-hight-2 border-bottom pb-3 montserrat">
                    Job Details
                  </h4>
                  {/* LOADING */}
                  {loading && <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>}

                  {/* ERROR */}
                  {error && <p className="text-danger">{error}</p>}
                  <div className="card shadow-sm p-4">
                    <div className="d-flex justify-content-between align-items-start mb-3">
                      <h2 className="text-primary">{job.title}</h2>
                      <span className={`badge ${getStatusClass(job.status)} py-2 px-3`}>
                        {job.status?.toUpperCase() || "N/A"}
                      </span>

                    </div>
                    <div className="row mb-3">
                      <div className="col-md-4 mb-2">
                        <strong>Job Type:</strong> {job.job_type}
                      </div>
                      <div className="col-md-4 mb-2">
                        <strong>Experience Level:</strong> {job.experience_level}
                      </div>
                      <div className="col-md-4 mb-2">
                        <strong>Duration:</strong> {job.duration}
                      </div>
                    </div>

                    <div className="row mb-3">
                      <div className="col-md-4 mb-2">
                        <strong>Salary:</strong> {job.currency} {job.salary_min} - {job.salary_max}
                      </div>
                      <div className="col-md-4 mb-2">
                        <strong>Remote:</strong> {job.remote ? "Yes" : "No"}
                      </div>
                      <div className="col-md-4 mb-2">
                        <strong>Number of Positions:</strong> {job.no_of_jobs}
                      </div>
                    </div>

                    <div className="row mb-3">
                      <div className="col-md-12">
                        <strong>Location:</strong> {job.city}, {job.state}, {job.country}
                      </div>
                    </div>

                    <div className="mb-3">
                      <h5>Description:</h5>
                      <div dangerouslySetInnerHTML={{ __html: job.description }} />
                    </div>

                    <div className="text-muted mt-3" style={{ fontSize: "0.9rem" }}>
                      Published At: {job.published_at} | Expires At: {job.expires_at}
                    </div>

                    <div className="text-muted mt-3" style={{ fontSize: "0.9rem" }}>
                      {role_id !== 3 && (
                        <div className="mt-4">

                          {/* 🔴 NOT VERIFIED → highest priority */}
                          {!isVerified && (
                            <button
                              className="btn btn-warning"
                              onClick={() => navigate("/panel/verify")}
                            >
                              Go to Verify
                            </button>
                          )}

                          {/* 🟠 VERIFIED but NOT COMPLIANT */}
                          {isVerified && !isCompliance && (
                            <button
                              className="btn btn-secondary"
                              onClick={() => navigate("/panel/compliance")}
                            >
                              Go to Compliance
                            </button>
                          )}

                          {/* 🟢 VERIFIED + COMPLIANT */}
                          {isVerified && isCompliance && (
                            <>
                              {isApplied ? (
                                <>
                                  <button className="btn btn-secondary" disabled>
                                    Already Applied
                                  </button>
                                  <p className="text-success mt-2 mb-0">
                                    You have already applied for this job.
                                  </p>
                                </>
                              ) : (
                                <button
                                  className="btn btn-primary"
                                  onClick={() => setShowModal(true)}
                                >
                                  Apply for Job
                                </button>
                              )}
                            </>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 mt-4 pt-4">

                <div className="support-card text-white bg-primary rounded15 p-4 mt-4">
                  <div className="p-md-2">
                    <h5 className="font-weight-semibold font-size-18 mb-3">Need Help?</h5>
                    <p className="mb-3">Reach out to our support executive<br />for any help</p>
                    <div className="phone-number my-4">
                      <img src="/assets/images/phone-call-01.svg" className="img-fluid" alt="" />
                      <span>+91-6353385120</span>
                    </div>
                    <a href="https://wa.me/916353385120" target="_blank" className="whatsapp-button">
                      <img src="/assets/images/chat-whatsapp-icon.svg" className="img-fluid" alt="" />
                      Chat on Whatsapp
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {showModal && (
            <div
              style={{
                position: "fixed",
                inset: 0,
                backgroundColor: "rgba(0,0,0,0.5)",
                zIndex: 1050,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div
                className="modal-dialog"
                style={{
                  pointerEvents: "auto",
                  maxWidth: "1000px",
                  width: "90%",
                }}
              >
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Apply for {job.title}</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setShowModal(false)}
                    />
                  </div>

                  <div className="modal-body">
                    <div className="mb-3">
                      <label className="form-label required">Select Resume</label>
                      <select
                        className="form-select"
                        value={selectedResume}
                        onChange={(e) => setSelectedResume(e.target.value)}
                      >
                        <option value="">-- Select Resume --</option>
                        {resumeData?.map((resume) => (
                          <option key={resume.id} value={resume.id}>
                            {resume.title}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="mb-3">
                      <label className="form-label required">Cover Letter</label>
                      <textarea
                        className="form-control"
                        rows="5"
                        value={coverLetter}
                        onChange={(e) => setCoverLetter(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="modal-footer">
                    <button
                      className="btn btn-secondary"
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </button>
                    <button className="btn btn-success" onClick={handleApply}>
                      Submit Application
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </section>
      </main>
      <WorkerFooter />
    </>
  );
};

export default WorkerJobDetails;